<template>
  <div class="biz-clazz-picker">
    <el-popover v-model="visible"
                width="420"
                popper-class="biz-clazz-picker-popover"
                :trigger="trigger"
                :placement="placement"
                v-bind="$attrs">
      <div class="biz-clazz-picker-cont">
        <div class="main">
          <ClazzPickerWrap ref="wrap"
                           v-bind="$attrs"
                           @start="handleStart"
                           @end="handleEnd"
                           @ready="handleReady"
                           @confirm="handlePicker"></ClazzPickerWrap>
        </div>
        <div v-if="ready"
             class="footer">
          <el-button size="mini"
                     type="primary"
                     @click="handlePicker">确定</el-button>
          <el-button size="mini"
                     type="default"
                     @click="hide">取消</el-button>
        </div>
      </div>
      <template slot="reference">
        <template v-if="$scopedSlots.default">
          <slot :loading="loading"
                :state="state"
                :clazz="clazz"
                :show="show"
                :hide="hide"></slot>
        </template>
        <template v-else>
          <el-input v-model="input"
                    class="biz-clazz-picker-input"
                    type="text"
                    :size="size"
                    :placeholder="placeholder">
            <template #suffix>
              <template v-if="loading">
                <span class="state-loading">
                  <i class="el-icon-loading"></i>
                </span>
              </template>
              <template v-else-if="state">
                <span v-if="state.type === 'success'"
                      class="state-success">
                  <i class="el-icon-success"></i>
                </span>
                <span v-else
                      class="state-fail">
                  <span v-if="state.info"
                        class="info">{{state.info}}</span>
                  <i class="el-icon-error"></i>
                </span>
              </template>
            </template>
          </el-input>
        </template>
      </template>
    </el-popover>
  </div>
</template>

<script>
import ClazzPickerWrap from './wrap'
export default {
  name: 'ClazzPicker',
  components: {
    ClazzPickerWrap
  },
  props: {
    value: String,
    inputValue: String,
    valueKey: {
      type: String,
      default: 'id'
    },
    inputKey: {
      type: String,
      default: 'name'
    },
    size: {
      type: String,
      default: 'mini'
    },
    trigger: {
      type: String,
      default: 'click'
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    placeholder: {
      type: String,
      default: '请选择班级'
    }
  },
  data () {
    return {
      visible: false,
      input: this.inputValue,
      loading: false,
      ready: false
    }
  },
  computed: {
    state () {
      if (this.ready) {
        let wrap = this.$refs.wrap
        if (wrap) {
          if (typeof this.input === 'string') {
            if (this.input) {
              return wrap.resolveClazz(this.input, this.inputKey)
            } else {
              return null
            }
          }
          if (this.value) {
            return wrap.resolveClazz(this.value, this.valueKey)
          }
        }
      }
    },
    clazz: {
      get () {
        let state = this.state
        if (state) {
          return state.data
        }
      },
      set (val) {
        if (val) {
          this.$emit('input', val[this.valueKey])
          this.input = val[this.inputKey]
        } else {
          this.$emit('input', '')
          this.input = ''
        }
      }
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    handleStart () {
      this.loading = true
    },
    handleEnd () {
      this.loading = false
    },
    handleReady () {
      this.ready = true
    },
    handlePicker () {
      let wrap = this.$refs.wrap
      if (wrap) {
        wrap.getClazz().then(clazz => {
          this.clazz = clazz
          this.$nextTick(() => {
            this.hide()
          })
        }, err => {
          this.$message.warning(err.message)
        })
      }
    },
    onChangeClazz (clazz) {
      if (clazz) {
        this.$emit('input', clazz[this.valueKey])
        if (!this.input) {
          this.input = clazz[this.inputKey]
        }
      }
    }
  },
  created () {
    if (this.clazz) {
      this.onChangeClazz(this.clazz)
    }
  },
  watch: {
    clazz (val) {
      if (val) {
        this.onChangeClazz(val)
      } else {
        this.$emit('input', '')
      }
    },
    value (val) {
      if (!val) {
        if (this.clazz) {
          this.clazz = null
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../styles/color";

  .biz-clazz-picker {
    .biz-clazz-picker-input {
      .el-input__suffix {
        display: flex;
        align-items: center;
        & > .el-input__suffix-inner {
          position: relative;
          top: -1px;
          .state-loading,
          .state-success,
          .state-fail {
            padding-right: 5px;
            i {
              font-size: 14px;
              vertical-align: -1px;
            }
            .info {
              margin-right: 2px;
              display: inline-block;
              transform: scale(.95);
            }
          }
          .state-loading {
            color: $set-info-color;
          }
          .state-success {
            color: $set-success-color;
          }
          .state-fail {
            color: $set-danger-color;
          }
        }
      }
    }
  }
  .biz-clazz-picker-popover {
    .el-popover__title {
      padding: 3px 5px!important;
    }
    .biz-clazz-picker-cont {
      & > .main {
        padding: 15px 5px 10px;
        box-sizing: border-box;
      }
      & > .footer {
        padding-top: 10px;
        background-color: #fff;
        border-top: 1px solid rgba(0,0,0,.05);
        text-align: center;
        .el-button {
          min-width: 90px;
        }
      }
    }
  }
</style>
